<template>
  <form-panel
    width="medium"
    title="Diseñar campaña"
    @closePanel="onClose">
    <el-form
      ref="FormCampaign"
      :model="model"
      :rules="rules"
      class="padding-20"
      @submit.native.prevent="onSubmit">
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            label="Nombre"
            prop="name">
            <el-input v-model.trim="model.name"/>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            label="Descripción"
            prop="description">
            <el-input
              v-model="model.description"
              :rows="4"
              type="textarea"
              resize="none"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Fecha de inicio"
            prop="startDate">
            <el-date-picker
              v-model="model.startDate"
              style="width: 100%"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Fecha de termino"
            prop="endDate">
            <el-date-picker
              v-model="model.endDate"
              style="width: 100%"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row
        type="flex"
        justify="end">
        <el-col :span="12">
          <el-button
            type="primary"
            native-type="submit">
            Guardar
          </el-button>
        </el-col>
      </el-row>
    </el-form>
  </form-panel>
</template>

<script>
import FormPanel from '@/components/_shared/form-panel'
import CampaignModel from '@/models/campaigns/campaign-model'
export default {
  name: 'CampaignCreatePanel',
  components: {
    FormPanel
  },
  props: {
    campaign: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      model: CampaignModel.model(),
      rules: CampaignModel.rules()
    }
  },
  mounted () {
    if (Object.keys(this.campaign).length > 0) {
      this.model = this.campaign
    }
  },
  methods: {
    onClose () {
      this.$store.dispatch('app/toggleCampaignCreatePanel')
    },
    onSubmit () {
      this.$refs['FormCampaign'].validate((valid) => {
        if (valid) {
          this.model.type = 'EMAIL'
          this.model.published = 'pending'
          this.$message.success('La campaña fue creada con éxito')
          this.$emit('onSendCampaign', this.model)
          this.$store.dispatch('app/toggleCampaignCreatePanel')
        } else {
          this.$notify.error({
            group: 'app',
            title: 'Verifica el formulario.',
            message: 'Por favor, revisa los errores que se indican dentro del formulario.'
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.el-button{
  width: 100%;
  background-color: $primary;
  color: #ffffff;
  box-shadow: 0 3px 6px 0 rgba(231, 18, 14, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/modules/campaigns/campaign-create-panel.vue